import { createPortal } from "react-dom";
import { X, Trash2, Clock } from "lucide-react";

export default function SavedEstimatesModal({ savedEstimates, activeEstimateId, onLoad, onDelete, onClose }) {
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  };

  return createPortal(
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
    >
      <div style={{ width: "100%", maxWidth: 480, maxHeight: "85vh", background: "#fff", borderRadius: 14, overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 24px 80px rgba(0,0,0,0.3)" }}>
        {/* Header */}
        <div style={{ padding: "18px 20px", borderBottom: "1px solid #F0F0F0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <h3 style={{ fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: 16, color: "#1A1A1A", margin: 0 }}>Saved Estimates</h3>
            <p style={{ fontFamily: "Inter, sans-serif", fontSize: 12, color: "#999", margin: "2px 0 0" }}>{savedEstimates.length} saved · most recent first</p>
          </div>
          <button onClick={onClose} style={{ background: "#F5F5F5", border: "none", borderRadius: "50%", width: 32, height: 32, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <X size={16} color="#888" />
          </button>
        </div>

        {/* List */}
        <div style={{ flex: 1, overflowY: "auto" }}>
          {savedEstimates.length === 0 ? (
            <div style={{ padding: "40px 20px", textAlign: "center" }}>
              <Clock size={32} color="#DDD" style={{ margin: "0 auto 12px", display: "block" }} />
              <p style={{ fontFamily: "Inter, sans-serif", fontSize: 13, color: "#999", margin: 0, lineHeight: 1.6 }}>
                No saved estimates yet.<br />Click "Save" to store an estimate for later.
              </p>
            </div>
          ) : (
            savedEstimates.map((est) => (
              <div
                key={est.id}
                onClick={() => { onLoad(est); onClose(); }}
                style={{
                  padding: "14px 20px",
                  borderBottom: "1px solid #F5F5F5",
                  cursor: "pointer",
                  background: activeEstimateId === est.id ? "#E8EDFF" : "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 12,
                  transition: "background 0.15s",
                }}
                onMouseEnter={(e) => { if (activeEstimateId !== est.id) e.currentTarget.style.background = "#FAFAFA"; }}
                onMouseLeave={(e) => { if (activeEstimateId !== est.id) e.currentTarget.style.background = "#fff"; }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ fontFamily: "Inter, sans-serif", fontSize: 14, fontWeight: activeEstimateId === est.id ? 600 : 500, color: "#1A1A1A", margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {est.address || "Untitled"}
                  </p>
                  <p style={{ fontFamily: "Inter, sans-serif", fontSize: 11, color: "#999", margin: "2px 0 0" }}>
                    {est.hostName || "—"} · {formatDate(est.created_date)}
                  </p>
                </div>
                <button
                  onClick={(e) => { e.stopPropagation(); onDelete(est.id); }}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: 6, display: "flex", alignItems: "center", flexShrink: 0 }}
                  title="Delete estimate"
                >
                  <Trash2 size={15} color="#CCC" />
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}